// 废水台账
<template>
  <div class="mapwrap" v-if="isRefresh">
    <div>
      <el-tabs class="pollutionSrcsTabs" v-model="tabType" v-if="tabData.length>1" @tab-click="handleRefresh()" stretch>
        <el-tab-pane v-for="(tabDataItem, tabDataIndex) in tabData" :key="tabDataIndex"
          :label="tabDataItem.tabTitle" :name="tabDataItem.tabIndex"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- table -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'table'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="addRow">新增</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'table'">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{tri+1}}</td>
          <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button type="text" size="mini" @click="editRow(tr)">编辑</el-button>
            <el-button type="text" size="mini" @click="saveRow(tr)">保存</el-button>
            <el-button type="text" size="mini" @click="deleteRow(tr)">删除</el-button>
            <!-- <el-button type="text" size="mini" @click="makeSure(item)">上传文件</el-button> -->
          </td>
        </tr>
      </table>
    </div>
    <!-- multiform -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'multiform'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="editForm()">编辑</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" @click="saveForm()">保存</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'multiform'">
      <table class="listTable" width="100%" border="1" align="center">
        <!-- <tr>
          <th class="cell thtitle" width="25%" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
        </tr> -->
        <tr v-for="(tr, tri) in tabDataCrt.multiformData" :key="tri">
          <td class="cell tdcell" width="25%" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tabDataCrt.editable && !tr.editFlag && td !== 'name'" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- other -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index'
export default {
  data () {
    return {
      tabType: 'tabA',
      companyName: '',
      // tabData
      tabData: [
        {
          tabTitle: '废水台账',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '起始时间',
            '终止时间',
            '台账类型'
          ],
          rowItems: [
            'startTime',
            'endTime',
            'bookType'
          ],
          api: {
            add: 'hbStandingBookAdd',
            enquiry: 'hbStandingBookEnquiry',
            update: 'hbStandingBookUpdate',
            delete: 'hbStandingBookDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
        // {
        //   tabTitle: '监测结果',
        //   tabIndex: 'tabB',
        //   tabType: 'table',
        //   tableNames: [
        //     '监测类别',
        //     '监测点位',
        //     '监测时间',
        //     '委托单位',
        //     '委托人',
        //     '监测单位',
        //     '监测结果',
        //     '报告日期',
        //     '标准限值',
        //     '依据标准'
        //   ],
        //   rowItems: [
        //     'monitorType',
        //     'monitorPoint',
        //     'monitorTime',
        //     'client',
        //     'entrustPeople',
        //     'monitorUnit',
        //     'monitorResult',
        //     'reportDate',
        //     'standardLimits',
        //     'standard'
        //   ],
        //   api: {
        //     add: 'hbEnvironmentalMonAdd',
        //     enquiry: 'hbEnvironmentalMonEnquiry',
        //     update: 'hbEnvironmentalMonUpdate',
        //     delete: 'hbEnvironmentalMonDelete',
        //     extraParam: {
        //       category: 3
        //     }
        //   },
        //   tableData: [{
        //     id: 0,
        //     editFlag: false
        //   }]
        // },
        // {
        //   tabTitle: '不监测原因管理',
        //   tabIndex: 'tabC',
        //   tabType: 'table',
        //   tableNames: [
        //     '省',
        //     '市',
        //     '县',
        //     '企业名称',
        //     '不监测名称',
        //     '不监测类型',
        //     '开始日期',
        //     '截至日期',
        //     '监测方式',
        //     '是否停产',
        //     '添加事件'
        //   ],
        //   rowItems: [
        //     'province',
        //     'city',
        //     'county',
        //     'enterpriseName',
        //     'notMonitorName',
        //     'notMonitorType',
        //     'startDate',
        //     'endDate',
        //     'monitorMode',
        //     'isStopProduction',
        //     'addEvent'
        //   ],
        //   api: {
        //     add: 'hbNonMonitoringAdd',
        //     enquiry: 'hbNonMonitoringEnquiry',
        //     update: 'hbNonMonitoringUpdate',
        //     delete: 'hbNonMonitoringDelete',
        //     extraParam: {
        //       category: 1
        //     }
        //   },
        //   tableData: [{
        //     id: 0,
        //     editFlag: false
        //   }]
        // },
        // {
        //   tabTitle: '用户信息管理',
        //   tabIndex: 'tabD',
        //   tabType: 'table',
        //   tableNames: [
        //     '监测方案名称',
        //     '版本',
        //     '企业名称',
        //     '创建时间',
        //     '方案执行时间',
        //     '状态'
        //   ],
        //   rowItems: [
        //     'schemeName',
        //     'edition',
        //     'enterpriseName',
        //     'creationTime',
        //     'executionTime',
        //     'type'
        //   ],
        //   api: {
        //     add: 'hbMonitoringProgrammeAdd',
        //     enquiry: 'hbMonitoringProgrammeEnquiry',
        //     update: 'hbMonitoringProgrammeUpdate',
        //     delete: 'hbMonitoringProgrammeDelete',
        //     extraParam: {
        //       category: 1
        //     }
        //   },
        //   tableData: [{
        //     id: 0,
        //     editFlag: false
        //   }]
        // },
        // {
        //   tabTitle: '企业改正情况',
        //   tabIndex: 'tabE',
        //   tabType: 'table',
        //   tableNames: [
        //     '改正问题',
        //     '改正措施',
        //     '整改排放口编号及名称',
        //     '整体具体措施',
        //     '备注',
        //     '时限要求',
        //     '状态'
        //   ],
        //   rowItems: [
        //     'correctProblem',
        //     'correctMeasures',
        //     'newNumName',
        //     'overallMeasures',
        //     'remarks',
        //     'timeLimit',
        //     'state'
        //   ],
        //   api: {
        //     add: 'hbEnterpriseCorrectionAdd',
        //     enquiry: 'hbEnterpriseCorrectionEnquiry',
        //     update: 'hbEnterpriseCorrectionUpdate',
        //     delete: 'hbEnterpriseCorrectionDelete',
        //     extraParam: {
        //       category: 1
        //     }
        //   },
        //   tableData: [{
        //     id: 0,
        //     editFlag: false
        //   }]
        // }
      ],
      tabDataCrt: {},
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true
    }
  },
  mounted () {
    this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    this.getTabData()
  },
  methods: {
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      console.log(this.tabType)
      this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.pageNo = 1
        this.getTabData()
      })
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    addRow () {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.add]({
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    editRow (row) {
      row.editFlag = true
    },
    saveRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        var savePusher = {
          id: row.id,
          ...this.tabDataCrt.api.extraParam
        }
        this.tabDataCrt.rowItems.forEach(rowItem => {
          console.log(row, rowItem, row[rowItem])
          savePusher[rowItem] = row[rowItem] || ''
        })
        api[this.tabDataCrt.api.update](savePusher).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    }
  },
  components: {
    // ehsTableImport
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.mapwrap{
  z-index: 0;
  height: 100%;
  overflow: hidden;
}
.pollutionSrcsTabs{
  margin: 0 10px;
}
.searchInput{
  width: 50%;
  margin: 4px 10px;
  // padding-left: 10px;
  display: flex;
  font-size: 16px;
  .searchInput-prepend{
    font-weight: bold;
  }
  // margin-top: 0;
  // .searchInput div{
  //   height: 40px;
  //   // line-height: 40px;
  // }
  // .searchLabel{
  //   padding-top: 1px;
  //   height: 32px;
  //   font-size: 17px;
  // }
  // .el-input__icon{
  //   width: 20px!important;
  //   line-height: 28px!important;
  // }
}
.btnRefresh{
  margin: 0 10px 0 0!important;
}
.btnUpdate{
  margin: 0 0 0 10px!important;
  width: 120px!important;
}
.mainTable{
  margin: 10px;
  width: calc(100% - 20px);
  .tableFileCell{
    text-decoration: underline;
    color: #00C;
  }
  .tableFileCell:hover{
    color: #66F;
    text-decoration: none;
  }
  .cell{
    border: 1px #ccc solid;
    text-align: center;
  }
  .thtitle{
    background-color: #fafafa;
    line-height: 24px;
  }
  .tdcell{
    background-color: #fff;
    line-height: 32px;
    padding: 2px;
    .el-input__inner{
      height: 28px!important;
    }
  }
}
.bottom-pagination .el-pagination {
  text-align: right;
  margin-top: 6px;
  margin-bottom: 6px;
}

.el-card{
  margin-top: 4px;
  .el-card__header{
    padding: 0;
  }
  .el-card__body{
    padding: 0;
    overflow-y: auto;
  }
}
</style>
